import { isCustomizedType, reduce } from "et3-type-guards";
import { Ti18nKeys } from "../../constants/i18n";

import i18nServerResponse from "../../constants/i18n-server-response";
import { post } from "../axios-post";
import { TIssueType } from "../../Types";

export const apiCallSaveAuditedEventAsSupervised = async ({
  eventID,
  issueType,
  reason_ids,
  proof
}: {
  eventID: number;
  issueType: TIssueType;
  reason_ids: number[];
  proof: string;
}): Promise<{
  data: string;
  status: string;
  code: Ti18nKeys;
}> => {
  const { status, data, et3Error } = await post<{
    adminPermissions: {
      moduleId: number;
      description: string;
      hasPermission: 0 | 1;
    }[];
  }>(`supervisor/saveAuditedEventAsSupervised`, {
    eventID,
    issueType,
    reason_ids,
    proof
  });
  if (
    status === "OK" &&
    !isCustomizedType<{
      errorCode: string;
      et3Message: string;
    }>(
      {
        errorCode: "ERROR",
        et3Message: "ERROR"
      },
      data
    )
  ) {
    return {
      data: "OK",
      status: "OK",
      code: "SUCCESS"
    };
  } else if (status === "ERROR") {
    const errorNumber = reduce(() => et3Error.errorNumber, 0);
    return {
      data: "ERROR",
      status: "ERROR",
      code: i18nServerResponse.get(errorNumber)
    };
  } else {
    return {
      data: "ERROR",
      status: "ERROR",
      code: "ERROR"
    };
  }
};
